import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { ComponentProps, useCallback } from 'react';
import { TeamMemberInfoModal } from './TeamMemberInfoModal';

export const useTeamMemberInfoModal = () => {
  const { openModal } = useDynamicModal();

  const openTeamMemberInfoModal = useCallback(
    (args: Omit<ComponentProps<typeof TeamMemberInfoModal>, 'onClose'>) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <TeamMemberInfoModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );

  return {
    openTeamMemberInfoModal,
  };
};
